import { AuditCard } from "@/pages/a7/Audit/AuditCard";
import i18n from "@/i18n";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { EditCardWrapper } from "@/features/Edit/EditCardWrapper.tsx";
import { a7FIAIssuerTsEditForm } from "@/pages/a7/EditForms/a7FIAIssuerTsEditForm.tsx";
import { getIssuerTsAuditColumns } from "./columns";

const table_name = "a7_fia_issuer_ts";

export const A7FIAIssuerTSEdit = () => {
  const { id } = useParams<{ id: string }>();
  const { t, i18n: i18nClient } = useTranslation(["tables"]);
  const auditColumns = useMemo(
    () => getIssuerTsAuditColumns(t),
    [t, i18nClient.language],
  );

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="h-full bg-gray-50">
      <div className="flex flex-col gap-10 p-10">
        <EditCardWrapper
          client={"a7"}
          id={Number(id)}
          headerText={t(`${table_name}.title`, {
            ns: "tables",
            defaultValue: "Issuer time series",
          })}
          {...a7FIAIssuerTsEditForm}
          disable_translations_request={true}
        />
        <AuditCard
          client={"a7"}
          id={Number(id)}
          name={table_name}
          audit_columns={auditColumns}
        />
      </div>
    </div>
  );
};
